// Shared helpers used across the HourLog modular components.
// Pulled out of the old monolithic HourLogPage.jsx (iter-110 refactor).

export function todayIso() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function fmtHMS(iso) {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        return d.toLocaleTimeString([], {
            hour: "numeric", minute: "2-digit", hour12: true,
        });
    } catch { return "—"; }
}

export function hoursBetween(a, b) {
    if (!a || !b) return 0;
    return Math.max((new Date(b) - new Date(a)) / 3600000, 0);
}

export function fmtDateLabel(iso) {
    if (!iso) return "";
    const d = new Date(iso + "T12:00:00");
    return d.toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" });
}
